// Tiny fetch wrapper that always sends cookies and prefixes REACT_APP_BACKEND_URL
const BASE = process.env.REACT_APP_BACKEND_URL;

async function request(method, path, body, opts = {}) {
  const res = await fetch(`${BASE}/api${path}`, {
    method,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(opts.headers || {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const err = new Error((data && (data.detail || data.message)) || res.statusText || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  get: (p, o) => request("GET", p, null, o),
  post: (p, b, o) => request("POST", p, b, o),
  put: (p, b, o) => request("PUT", p, b, o),
  del: (p, o) => request("DELETE", p, null, o),
};

export const endpoints = {
  me: () => api.get("/auth/me"),
  logout: () => api.post("/auth/logout"),
  sessionExchange: (session_id) => api.post("/auth/session-exchange", { session_id }),

  awards: () => api.get("/awards"),
  speaking: () => api.get("/speaking"),
  insights: () => api.get("/insights"),
  certifications: () => api.get("/certifications"),
  caseStudies: () => api.get("/case-studies"),
  publications: () => api.get("/publications"),
  submitContact: (payload) => api.post("/contact", payload),

  admin: {
    list: (r) => api.get(`/admin/${r}`),
    create: (r, body) => api.post(`/admin/${r}`, body),
    update: (r, id, body) => api.put(`/admin/${r}/${id}`, body),
    remove: (r, id) => api.del(`/admin/${r}/${id}`),
    inbox: () => api.get("/admin/contact-submissions"),
    removeInbox: (id) => api.del(`/admin/contact-submissions/${id}`),
  },
};
